import { useRef } from 'react';
import {
  Avatar,
  AvatarGroup,
  Box,
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { ChevronDown } from '@kula-ai/icons-core';

export const TaggedUsers = ({ taggedUsers = [] }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const ref = useRef();

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  return (
    <Box ref={ref}>
      <Popover isOpen={isOpen} placement="bottom-end">
        <PopoverTrigger>
          <Flex
            alignItems="center"
            gap="6px"
            onClick={onToggle}
            cursor="pointer"
          >
            <AvatarGroup
              size="xs"
              max="3"
              sx={{
                '.chakra-avatar__excess': {
                  fontSize: '12px',
                  ml: '-8px',
                  borderRadius: '6px',
                },
              }}
            >
              {taggedUsers?.map((user, idx) => (
                <Avatar
                  key={idx}
                  src={user.image_url}
                  name={user?.name}
                  borderRadius="sm"
                />
              ))}
            </AvatarGroup>
            <Icon as={ChevronDown} />
          </Flex>
        </PopoverTrigger>
        <PopoverContent maxW="200px" maxH="350px" overflowY="auto">
          <PopoverBody display="flex" flexDir="column" gap="12px">
            {taggedUsers?.map((user) => {
              return (
                <Flex key={user.id} gap="12px" alignItems="center">
                  <Avatar
                    src={user.avatar}
                    name={user?.name}
                    borderRadius="sm"
                    size="xs"
                  />
                  <TruncatedTextWithTooltip
                    fontSize="sm"
                    textTransform="capitalize"
                    text={user?.name}
                  />
                </Flex>
              );
            })}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
